module.exports = __webpack_public_path__ + "static/img/3798_phase_function_Paper_Points.86f20ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3798_phase_function_Paper_Points.png
// module id = vX1c
// module chunks = 0